module.exports = '<svg width="30" height="32" viewBox="0 0 30 32"><path d="M28.235 5.647h-5.647V1.882C22.588.841 22.059 0 21.018 0H9.724C8.683 0 7.529.841 7.529 1.882v3.765H1.882A1.88 1.88 0 0 0 0 7.529v22.588a1.88 1.88 0 0 0 1.882 1.882h26.353a1.88 1.88 0 0 0 1.882-1.882V7.529a1.88 1.88 0 0 0-1.882-1.882zM11.294 3.765h7.529v1.882h-7.529V3.765zm3.765 22.588a7.53 7.53 0 1 1 0-15.058 7.53 7.53 0 0 1 0 15.058zm3.765-7.529a3.765 3.765 0 1 1-7.53 0 3.765 3.765 0 0 1 7.53 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/camera-2.js
// module id = 1044
// module chunks = 14